import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PdfFooter from 'src/overrides/venia-ui/components/WishlistPage/Pdf/PdfFooter/index.js';
import PdfNotes from 'src/overrides/venia-ui/components/WishlistPage/Pdf/PdfNotes/index.js';
import PdfHeading from 'src/overrides/venia-ui/components/WishlistPage/Pdf/PdfHeading/index.js';
import defaultClasses from './tearsheetPDF.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import BaseInfo from './baseInfo';
import BulbRecommendation from './bulbRecommendation';
import SpecificationsPDF from './specificationsPDF';
import OptionsPDF from './optionsPDF';

var TearsheetPDF = /*#__PURE__*/function (_Component) {
  _inherits(TearsheetPDF, _Component);

  var _super = _createSuper(TearsheetPDF);

  function TearsheetPDF(props) {
    var _this;

    _classCallCheck(this, TearsheetPDF);

    _this = _super.call(this, props);
    _this.state = {
      images: []
    };
    return _this;
  }

  _createClass(TearsheetPDF, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      var pdfOptions = this.props.pdfOptions;
      var classes = useStyle(defaultClasses, this.props.classes);
      return React.createElement("div", {
        className: classes.root
      }, React.createElement(PdfHeading, {
        showContactInfo: false
      }), React.createElement(BaseInfo, {
        productDetails: this.props.productDetails,
        customAttributes: this.props.customAttributes,
        product: this.props.product,
        optionSelections: this.props.optionSelections,
        itemId: this.props.itemId,
        smartString: this.props.smartString,
        pdfData: this.props.pdfData
      }), React.createElement(SpecificationsPDF, {
        customAttributes: this.props.customAttributes,
        weight: this.props.weight,
        productDetails: this.props.productDetails
      }), React.createElement(BulbRecommendation, {
        product: this.props.product,
        isPDF: true
      }), React.createElement("div", {
        className: classes.divider
      }), React.createElement(OptionsPDF, {
        disabledValuesMap: this.props.disabledValuesMap,
        product: this.props.product
      }), React.createElement("div", {
        className: "mt-auto"
      }, React.createElement(PdfNotes, {
        note: pdfOptions === null || pdfOptions === void 0 ? void 0 : pdfOptions.note
      }), React.createElement(PdfFooter, null)));
    }
  }]);

  return TearsheetPDF;
}(Component);

export default TearsheetPDF;